import React from 'react';
import { BorderOutlined, SyncOutlined, CheckCircleOutlined, CloseCircleOutlined, EyeOutlined } from '@ant-design/icons';

export interface StatusConfig {
  label: string;
  color: string;
  icon: React.ReactNode;
}

export const STATUS_CONFIG: Record<string, StatusConfig> = {
  open: { label: 'Open', color: '#1677ff', icon: <BorderOutlined /> },
  in_progress: { label: 'In Progress', color: '#d46b08', icon: <SyncOutlined /> },
  in_review: { label: 'In Review', color: '#722ed1', icon: <EyeOutlined /> },
  done: { label: 'Done', color: '#389e0d', icon: <CheckCircleOutlined /> },
  cancelled: { label: 'Cancelled', color: '#8c8c8c', icon: <CloseCircleOutlined /> },
};

export const STATUS_COLUMNS = Object.entries(STATUS_CONFIG).map(([key, cfg]) => ({ key, ...cfg }));
